import { cloneListOfCloneable, DataModelBuilder, isSameData,
  isSameList, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';
import { PoolAttendanceGroup } from './pool-attendance-group.js';

export class PoolAttendanceComponent extends Component {
  static readonly TYPE_ID: string = 'bfa930799c59401a85556a217d418baf';

  public readonly groups: PoolAttendanceGroup[];

  constructor(
      groups: PoolAttendanceGroup[] | null = null,
  ) {
    super();

    this.groups = groups ?? [];
  }

  get $removable(): boolean {
    return false;
  }

  get $typeId(): string {
    return PoolAttendanceComponent.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): PoolAttendanceComponent {
    return new PoolAttendanceComponent(
        MapUtils.getList(map, 'groups', (e) => context.fromData(e as SerializedData)),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'groups': this.groups.map((e) => context.toData(e)),
    };
  }

  clone(): this {
    return new PoolAttendanceComponent(
        cloneListOfCloneable(this.groups),
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameList(other.groups, this.groups, (a, b) => isSameData(a, b));
  }

  getAttendance(): number {
    let result = 0;

    for(const group of this.groups) {
      result += group.groupSize;
    }

    return result;
  }

  getNumberOfAdults(): number {
    let result = 0;

    for(const group of this.groups) {
      result += group.numberOfAdults;
    }

    return result;
  }

  getNumberOfChildren(): number {
    let result = 0;

    for(const group of this.groups) {
      result += group.numberOfChildren;
    }

    return result;
  }

  getNumberOfStudents(): number {
    let result = 0;

    for(const group of this.groups) {
      result += group.numberOfStudents;
    }

    return result;
  }

  getNumberOfPensioners(): number {
    let result = 0;

    for(const group of this.groups) {
      result += group.numberOfPensioners;
    }

    return result;
  }
}

export class PoolAttendanceComponentBuilder extends DataModelBuilder<PoolAttendanceComponent> {
  build(context: SerializationContext, map: SerializedData): PoolAttendanceComponent {
    return PoolAttendanceComponent.fromMap(context, map);
  }
}
